import { Col, Form, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { useContext, useEffect, useState } from 'react';
import hocFrom from "../../../../components/forms/HocFrom";
import InputControl from "../../../../components/inputs/InputControl";
import InputNumber from "../../../../components/inputs/InputNumber";
import Loader from "../../../../components/layout/Loader";
import { Table } from "antd";
import DashboardContext from "../../../../Context"
import Axios from 'axios';
import { AlignType } from 'rc-table/lib/interface'
import InputDate from "../../../../components/inputs/InputDate";
import { Collapse } from 'antd';
import { Button, Space } from 'antd';
import ModalDetailTransactions from "../ModalDetailTransactions";

const CustomerFinancialReport = () => {

    const { urldashboard, authentication } = useContext(DashboardContext);
    const [data, setDataFech] = useState([]);
    const [loading, setLoading] = useState(true);
    const [customerNameSearch, setCustomerNameSearch] = useState('');
    const [customerName, setCustomerName] = useState('');
    const [nameSearch, setSearchName] = useState('');
    const [fromDate, setFromDate] = useState(undefined);
    const [showModalDetailTransaction, setShowModalDetailTransaction] = useState(false);
    const [toDate, setToDate] = useState(undefined);
    const [totoalRecord, setTotalRecord] = useState(0);
    const [userId, setUserId] = useState(0);
    const [excelLoading, setExcelLoading] = useState(false);
    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 20,
    });

    useEffect(() => {
        datafeching({ page: 1, pageSize: 20, searchName: nameSearch, fromDate: undefined, toDate: undefined })
        return () => {

        }
    }, [])

    const handelValueFromDate = (name, value) => {
        setFromDate(value);
    }

    const handelValueToDate = (name, value) => {
        setToDate(value);
    }

    const getExcelReport = async ({ page, pageSize, serachName, fromDate, toDate }) => {

        setExcelLoading(true);

        try {

            let url = '/CustomerFinancialReport/getexcel';

            const res = await Axios.post(urldashboard + url, JSON.stringify({ page, pageSize, serachName, fromDate, toDate }), {
                headers: {
                    "Authorization": authentication,
                    "Content-Type": "application/json",
                }, responseType: 'arraybuffer'
            })

            let blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }); // change resultByte to bytes
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "CustomerReport.xlsx";
            link.click();

            setExcelLoading(false);
        } catch (error) {
            setExcelLoading(false);
            //handelerrors(error)
        }
    }

    const getExcel = () => {

        setExcelLoading(true);
        getExcelReport({
            page: pagination.page,
            pageSize: pagination.pageSize,
            nameSearch: nameSearch,
            fromDate: fromDate,
            toDate: toDate
        });
    }

    const datafeching = async ({ page, pageSize, searchName, fromDate, toDate }) => {

        setLoading(true);

        try {

            let url = '/CustomerFinancialReport/get';

            const res = await Axios.post(urldashboard + url, JSON.stringify({
                page,
                pageSize,
                searchName,
                fromDate,
                toDate
            }), {
                headers: {
                    "Authorization": authentication,
                    "Content-Type": "application/json"
                }
            })

            const data = await res.data

            setDataFech(data.data)

            setTotalRecord(data.totalRecord)

            setPagination({
                page: page,
                pageSize: pageSize,
                total: data.totalRecord, // 200 is mock data, you should read it from server
                // total: data.totalCount,
            });

            setLoading(false);
        } catch (error) {
            setLoading(false);
            alert('خطایی رخ داده است!')
            setDataFech([]);
        }
    }

    const showTransactions = (userId) => {
        let customerName = data.filter(x => x.customerId === userId)[0].customerName;
        setCustomerName(customerName);
        setUserId(userId);
        setShowModalDetailTransaction(true);
    }

    const handleTableChange = (newPagination, filters, sorter) => {
        // datafeching({
        //     sortField: sorter.field,
        //     sortOrder: sorter.order,
        //     pagination: newPagination,
        //     ...filters,
        // });
        // setPagination({
        //     page: newPagination.current,
        //     pageSize: newPagination.pageSize
        // });
        //let page = 0;
        datafeching({
            page: newPagination.current,
            pageSize: newPagination.pageSize,
            searchName: nameSearch,
            fromDate: fromDate,
            toDate: toDate
        });
    };

    const columns = [
        {
            title: 'ردیف',
            dataIndex: 'index',
            key: 'index',
            width: '3%',
            render: (item, record, index) => (<>{(index + 1) + ((pagination?.page - 1) * pagination?.pageSize)}</>)
        },
        {
            title: 'نام مشتری',
            dataIndex: 'customerName',
            key: 'customerName',
            width: '12%'
        },
        {
            title: 'شماره همراه',
            dataIndex: 'phoneNumber',
            key: 'phoneNumber',
            width: '7%'
        },
        {
            title: 'کد ملی',
            dataIndex: 'nationalCode',
            key: 'nationalCode',
            width: '5%'
        },
        {
            title: 'مجموع واریزی موفق',
            dataIndex: 'sumOfIcreaseAmount',
            key: 'sumOfIcreaseAmount',
            width: '5%',
            render: (item, record, index) => (item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
        },
        {
            title: 'تعداد تراکنش موفق',
            dataIndex: 'numberOfTransactions',
            key: 'numberOfTransactions',
            width: '5%'
        },
        {
            title: 'مجموع واریزی ناموفق',
            dataIndex: 'sumOfFaildAmount',
            key: 'sumOfFaildAmount',
            width: '5%',
            render: (item, record, index) => (item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
        },
        {
            title: 'تعداد تراکنش ناموفق',
            dataIndex: 'numberOfFaildTransactions',
            key: 'numberOfFaildTransactions',
            width: '5%'
        },
        {
            title: 'مجموع واریزی در انتظار',
            dataIndex: 'sumOfPendingAmount',
            key: 'sumOfPendingAmount',
            width: '5%',
            render: (item, record, index) => (item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
        },
        {
            title: 'تعداد تراکنش در انتظار',
            dataIndex: 'numberOfPendingTransactions',
            key: 'numberOfPendingTransactions',
            width: '5%'
        },
        {
            title: 'شرح تراکنش ها',
            dataIndex: 'customerId',
            key: 'cutomerId',
            width: '5%',
            render: (item, record, index) => (<button onClick={() => showTransactions(item)} className="btn btn-primary btn-sm">جزئیات</button>)
        }
    ];

    const customerSerach = (event) => {
        setSearchName(event.target.value);
    }

    const handelHideModalDetailTransaction = () => {
        setShowModalDetailTransaction(false);
    }

    const search = () => {
        datafeching({
            page: 1,
            pageSize: 20,
            searchName: nameSearch,
            fromDate: fromDate,
            toDate: toDate
        })
    }

    const { Panel } = Collapse;

    const reset = () => {
        setFromDate(undefined)
        setToDate(undefined)
        setCustomerNameSearch('')
        datafeching({
            page: 1,
            pageSize: 20,
            serachName: '',
            orderLessCount: null,
            orderMoreCount: null,
            fromDate: undefined,
            toDate: undefined
        })
    }

    return (
        <>

            {showModalDetailTransaction ? (
                <ModalDetailTransactions
                    showitem={showModalDetailTransaction}
                    handleCloseMoudal={handelHideModalDetailTransaction}
                    userId={userId}
                    fromDate={fromDate}
                    toDate={toDate}
                    customerName={customerName}
                />
            ) : null}

            <div style={{ display: 'flex', flexDirection: 'row' }}>

                <div style={{ flex: 1, marginLeft: 15 }}>

                    <Collapse defaultActiveKey={['0']} >
                        <Panel header="جستجو" key="1">

                            <div style={{ display: "flex" }}>
                                <div className="col-md-6">
                                    <InputDate label='از تاریخ' name='fromDate' defaultValue={fromDate} handelValue={handelValueFromDate} />
                                </div>
                                <div className="col-md-6">
                                    <InputDate label='تا تاریخ' name='toDate' defaultValue={toDate} handelValue={handelValueToDate} />
                                </div>
                            </div>

                            <div style={{ display: "flex" }}>
                                <div className="col-md-12">
                                    <input className="form-control" value={nameSearch} onChange={customerSerach} type='text' placeholder="جستجوی مشتری با نام یا شماره موبایل"></input>
                                </div>
                            </div>

                            <div className="row" style={{ display: "flex", marginTop: 20 }}>
                                <div className="col-md-6">
                                    <Button
                                        type="primary"
                                        style={{ width: '100%' }}
                                        loading={loading}
                                        onClick={() => search()}
                                    >
                                        جستجو
                                    </Button>
                                </div>
                                <div className="col-md-6">
                                    <Button
                                        type="primary" danger ghost
                                        style={{ width: '100%' }}
                                        onClick={() => reset()}
                                    >
                                        پاک کردن فرم جستجو
                                    </Button>
                                </div>
                            </div>
                        </Panel>
                    </Collapse>

                </div>

                {
                    excelLoading ? <i class="fas fa-sync fa-spin">
                        <i style={{ fontSize: '40px', color: 'red' }} class="fa fa-file-excel-o" aria-hidden="true"></i>
                    </i> : <i style={{ fontSize: '40px', color: 'red' }} onClick={() => getExcel()} class="fa fa-file-excel-o" aria-hidden="true"></i>
                }


            </div>

            <Table
                size="small"
                style={{ textAlign: 'right', marginTop: 20 }}
                rowClassName={(row, index) => 'center'}
                columns={columns}
                bordered={true}
                //rowKey={(record) => record.login.uuid}
                dataSource={data}
                pagination={pagination}
                loading={loading}
                onChange={handleTableChange}
            // expandable={{
            //     expandedRowRender: record => <p style={{ margin: 0 }}>{record.customerName}</p>,
            //     rowExpandable: record => record.customerName !== 'Not Expandable',
            // }}
            />
            <div style={{ marginTop: -40 }}>
                تعداد کل:{totoalRecord}
                <br />
                {/* جمع کل فروش:{totoalAmountSale.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") } */}
            </div>

        </>

    );
}

export default hocFrom(CustomerFinancialReport);
